import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var ColorImagesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default ColorImagesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/VariantImages/VariantImagesReduxProps.ts
// module id = 502
// module chunks = 0